import React from "react";
import { connect } from "react-redux";
import { useMemo } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import classnames from "classnames";
import NavigationActions from "redux/navigation/actions";
import ReactTableWrapper from "../../../components/reacttable/reacttbl.style";
import Pagination from "@mui/material/Pagination";
import PlaceHolderImage from "../../../assets/images/placeholder.png";

const { success, error } = NavigationActions;
const Staffservicetable = props => {
  const { staffData, staffServiceMap, loading } = props;

  const uniqueStaffData = useMemo(() => {
    if (!staffData || !staffData.length) return [];

    const serviceToStaff = new Map();
    (staffServiceMap || []).forEach(entry => {
      const sid = entry?.service_id;
      if (!sid) return;
      serviceToStaff.set(sid, new Set(entry.staff_data || []));
    });

    const seen = new Map();
    staffData.forEach(item => {
      const key = item._id || item.id || JSON.stringify(item);
      if (seen.has(key)) return;
      const staffId = item._id || item.id;
      const filteredServices = (item.service_data || []).filter(svc => {
        const svcId = svc._id || svc.id;
        const staffSet = serviceToStaff.get(svcId);
        return staffSet ? staffSet.has(staffId) : false;
      });
      seen.set(key, { ...item, filtered_service_data: filteredServices });
    });

    return Array.from(seen.values());
  }, [staffData, staffServiceMap]);

  const HeaderComponent = props => {
    let classes = {
      "my-2": true,
      "mx-3": true,
      "-sort-asc": props.isSortedDesc === false,
      "-sort-desc": props.isSortedDesc === true
    };
    return <div className={classnames(classes)}>{props.title}</div>;
  };
  const columns = useMemo(
    () => [
      {
        Header: tableInstance => {
          return (
            <HeaderComponent
              isSortedDesc={tableInstance.column.isSortedDesc}
              title="Staff-Image"
            />
          );
        },
        placeholder: "staff_image",
        accessor: "file_image",
        Cell: tableInstance => (
          <span>
            <img
              src={
                tableInstance.row.original?.file_image
                  ? `${process.env.REACT_APP_UPLOAD_DIR}${tableInstance.row.original?.file_image}`
                  : PlaceHolderImage
              }
              className="profile-img"
              onError={e => {
                e.target.src = PlaceHolderImage;
              }}
              alt="no"
              width={60}
            />
          </span>
        )
      },
      {
        Header: tableInstance => {
          return (
            <HeaderComponent
              isSortedDesc={tableInstance.column.isSortedDesc}
              title="Staff-Name"
            />
          );
        },
        placeholder: "staff_name",
        accessor: "name",
        Cell: tableInstance => <span>{tableInstance.row.original?.name}</span>
      },
      {
        Header: tableInstance => {
          return (
            <HeaderComponent
              isSortedDesc={tableInstance.column.isSortedDesc}
              title="Staff-Email"
            />
          );
        },
        placeholder: "staff_email",
        accessor: "email",
        Cell: tableInstance => <span>{tableInstance.row.original?.email}</span>
      },
      {
        Header: tableInstance => {
          return (
            <HeaderComponent
              isSortedDesc={tableInstance.column.isSortedDesc}
              title="Services"
            />
          );
        },
        placeholder: "services",
        accessor: "filtered_service_data",
        Cell: tableInstance => {
          const services =
            tableInstance.row.original?.filtered_service_data || [];
          return (
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "8px",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              {services.length > 0 ? (
                services.map((service, index) => (
                  <span
                    key={service._id || index}
                    style={{
                      display: "inline-block",
                      padding: "4px 12px",
                      fontSize: "12px",
                      fontWeight: "500",
                      backgroundColor: "#e3f2fd",
                      color: "#1976d2",
                      borderRadius: "16px",
                      whiteSpace: "nowrap"
                    }}
                  >
                    {service.name}
                  </span>
                ))
              ) : (
                <span style={{ color: "#999", fontSize: "14px" }}>
                  No services assigned
                </span>
              )}
            </div>
          );
        }
      }
    ],
    [uniqueStaffData, staffServiceMap]
  );
  const {
    getTableProps,
    getTableBodyProps,
    prepareRow,
    page,
    headerGroups
  } = useTable(
    {
      data: uniqueStaffData,
      columns: columns,
      initialState: {
        pageSize: 10,
        pageIndex: 0
      }
    },
    useSortBy,
    usePagination
  );
  return (
    <ReactTableWrapper {...props}>
      <div className="roe-card-style mt-15 mb-30">
        <div className="roe-card-header">
          <span className="hash"># </span> Room-Staff
        </div>
        <div className="table-container text-left overflow-auto mt-4">
          <table
            border={1}
            className="custom-react-table-theme-class"
            {...getTableProps()}
          >
            <thead>
              {headerGroups.map(headerGroup => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map(header => (
                    <th
                      {...header.getHeaderProps(header.getSortByToggleProps())}
                    >
                      <div>{header.render("Header")}</div>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>

            <tbody {...getTableBodyProps()}>
              {uniqueStaffData.length > 0
                ? page?.map(row => {
                    prepareRow(row);
                    return (
                      <tr {...row.getRowProps()}>
                        {row.cells.map(cell => (
                          <td {...cell.getCellProps()}>
                            {cell.render("Cell")}
                          </td>
                        ))}
                      </tr>
                    );
                  })
                : !loading && (
                    <tr>
                      {
                        <td className="mt-4 text-left font-weight-bold">
                          <h5>No data found</h5>
                        </td>
                      }
                    </tr>
                  )}
            </tbody>
          </table>
        </div>
        <div className="float-right" style={{ display: "none" }}>
          <Pagination
            // onPageChange={gotoPage}
            pages={1}
            // page={pageIndex}
            // count={pageCount}
            onChange={(e, val) => {
              // setPageCng(val);
            }}
          />
        </div>
      </div>
    </ReactTableWrapper>
  );
};
const mapStateToProps = state => {
  return {
    ...state.themeChanger,
    token: state.auth.accessToken
  };
};
export default compose(
  withRouter,
  connect(mapStateToProps, { success, error })
)(Staffservicetable);
